import LegalShell from "./LegalShell";

export default function SecurityRetention() {
  return (
    <LegalShell
      eyebrow="Legal · PNC UNIQUE LTD"
      title="Security & Retention"
      updated="February 2026"
      testid="security-page"
    >
      <p>
        This document describes the technical and organisational measures we apply to protect data processed
        through the <strong>PNC Absence Notifications Portal</strong>, and how long we keep it.
      </p>

      <h2>1. Data at rest</h2>
      <ul>
        <li>All Portal data is stored in an encrypted MongoDB Atlas cluster hosted in the EU region.</li>
        <li>Database volumes are encrypted at rest using AES-256.</li>
        <li>Automated daily backups are retained for 30 days on an encrypted, isolated backup service.</li>
      </ul>

      <h2>2. Data in transit</h2>
      <ul>
        <li>All traffic between browsers, the application and the database is encrypted with TLS 1.2 or above.</li>
        <li>HSTS is enforced on production hostnames.</li>
        <li>Session tokens are issued over HTTPS only and are short-lived.</li>
      </ul>

      <h2>3. Access control</h2>
      <ul>
        <li>Named accounts for all supervisors and administrators; no shared logins.</li>
        <li>Role-based access: contractors, supervisors and administrators only see the data required for their role.</li>
        <li>Passwords are stored as salted, one-way bcrypt hashes; the plaintext is never recorded.</li>
        <li>Administrative access to production infrastructure is limited to authorised PNC personnel and is auditable.</li>
      </ul>

      <h2>4. Audit trail</h2>
      <p>
        Every submission, approval, rejection and cancellation is recorded with the identity of the actor,
        a UTC timestamp and (where applicable) the reason provided. Audit records are immutable to standard
        Portal users and are retained per the schedule below.
      </p>

      <h2>5. Retention schedule</h2>
      <ul>
        <li><strong>Absence notifications</strong> and associated audit trail — retained for <strong>6 years</strong> after the end of the contractor&apos;s engagement, in line with statutory limitation periods under the Limitation Act 1980.</li>
        <li><strong>Contractor and supervisor records</strong> — retained for <strong>6 years</strong> after end of engagement.</li>
        <li><strong>Authentication and access logs</strong> — retained for <strong>12 months</strong>.</li>
        <li><strong>Email delivery logs</strong> (Resend) — retained for <strong>12 months</strong>.</li>
        <li><strong>Database backups</strong> — rolling 30-day window.</li>
      </ul>
      <p>
        After the retention period expires, records are deleted or irreversibly anonymised.
      </p>

      <h2>6. Incident response</h2>
      <ul>
        <li>We monitor error rates, authentication failures and unusual access patterns.</li>
        <li>Any personal-data breach that is likely to result in a risk to individuals&apos; rights is reported to the ICO within 72 hours of PNC becoming aware of it, and to affected individuals where required.</li>
        <li>Post-incident, we conduct a root-cause review and document remediation actions.</li>
      </ul>

      <h2>7. Sub-processors</h2>
      <ul>
        <li><strong>MongoDB Atlas</strong> — database hosting (EU region).</li>
        <li><strong>Resend</strong> — transactional email.</li>
        <li><strong>Emergent</strong> — application hosting.</li>
      </ul>
      <p>All sub-processors are bound by written data-processing agreements including confidentiality, security and audit rights.</p>

      <h2>8. Contact</h2>
      <p>
        Security concerns or suspected incidents should be reported immediately to
        <a href="mailto:admin@pncunique.com"> admin@pncunique.com</a> or on 0333 090 5024.
      </p>
    </LegalShell>
  );
}
